export const depositCardButtonSrcDoc = `
  <html>
    <body style="margin:0;display:flex;justify-content:flex-start;align-items:flex-start;">
              <button id="backBtn" style="
                position: fixed;
                width: 42px;
                height: 42px;
                cursor: pointer;
                border: 1px solid #d0d0d0;
                border-radius: 9999px;
                background-color: #ffffff;
                cursor: pointer;
                box-shadow: 0 4px 12px rgba(0,0,0,0.1);
                display: flex;
                align-items: center;
                justify-content: center;
                margin-left: 5px;
                margin-top: 5px;
                z-index: 9999;
                padding: 0;
              ">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M6 6L18 18M6 18L18 6" stroke="currentColor" stroke-width="2"/>
                </svg>
              </button>
      <script>
        document.getElementById('backBtn').onclick = () => {
          parent.postMessage({ type: 'BUTTON_IFRAME_BACK' }, '*');
        }
      </script>
    </body>
  </html>
`;
